import { render, staticRenderFns } from "./VInputNumeric.vue?vue&type=template&id=3f221cba&"
import script from "./VInputNumeric.vue?vue&type=script&lang=ts&"
export * from "./VInputNumeric.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports